<template>
  <div class="user-management">
    <h3>Kullanıcı Yönetimi</h3> 

    <div class="alert info"> 
      Kendi güvenliğimiz için, bir kullanıcıyı silmemek önemlidir. <br>
      Eğer silerseniz tüm veriler kalıcı olarak silinir. <br>
      Bunun yerine, Kullanıcıyı düzenle butonu ile "Aktif" yazan hesap durumunu "Askıya Alındı" olarak değiştirebilirsiniz. Erişimlerini kaybeder.
    </div>

    <h3>{{ isEdit ? "Kullanıcı Düzenle" : "Yeni Kullanıcı Ekle" }}</h3>
    <form @submit.prevent="isEdit ? updateUser() : createUser()">
      <input v-model="selectedUser.user_name" placeholder="Kullanıcı Adı" required />
      <input v-model="selectedUser.e_mail" placeholder="E-posta" type="email" required />
      <input v-if="!isEdit" v-model="selectedUser.password" placeholder="Şifre" type="password" required />
      <input v-model="selectedUser.first_name" placeholder="Ad" />
      <input v-model="selectedUser.last_name" placeholder="Soyad" />
      <input v-model="selectedUser.phone_number" placeholder="Telefon" />
      <input v-model="selectedUser.country" placeholder="Ülke" />
      <input v-model="selectedUser.address" placeholder="Adres" />
      <input v-model="selectedUser.gender" placeholder="Cinsiyet" />
      <input v-model="selectedUser.birth_date" placeholder="Doğum Tarihi" type="date" />
      <select v-model="selectedUser.account_status">
        <option value="Active">Aktif</option>
        <option value="Suspended">Askıya Alındı</option>
        <option value="Inactive">Pasif</option>
      </select>
      <select v-model="selectedUser.role_id">
        <option v-for="role in roles" :key="role.role_id" :value="role.role_id">{{ role.role_name }}</option>
      </select>
      <select v-model="selectedUser.verified_level" required>
        <option v-for="level in levels" :key="level.value" :value="String(level.value)">
          {{ level.label }}
        </option>
      </select>
      <button type="submit">{{ isEdit ? "Güncelle" : "Kullanıcı Ekle" }}</button>
    </form>   

    <div class="table-header">
      <h3>Tüm Kullanıcılar</h3>
      <label>
        <input type="checkbox" v-model="showDeleteButtons" /> Silme Butonlarını Göster
      </label>
    </div>
    <div class="search-filters">
      <input v-model="searchEmail" placeholder="E-posta ile ara" />
      <input v-model="searchPhone" placeholder="Telefon ile ara" />
    </div>
    <table>
      <thead>
        <tr>
          <th @click="sortBy('user_id')" style="cursor:pointer;">
            ID
            <span v-if="sortKey === 'user_id'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th @click="sortBy('user_name')" style="cursor:pointer;">
            Kullanıcı Adı
            <span v-if="sortKey === 'user_name'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th>E-posta</th>
          <th>Ad</th>
          <th>Soyad</th>
          <th>Telefon</th>
          <th>Ülke</th>
          <th>Adres</th>
          <th>Cinsiyet</th>
          <th>Doğum Tarihi</th>
          <th @click="sortBy('account_status')" style="cursor:pointer;">
            Durum
            <span v-if="sortKey === 'account_status'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th>Son Giriş</th>
          <th>Rol</th>
          <th>Level</th>
          <th>İşlemler</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in sortedFilteredUsers" :key="user.user_id">
          <td>{{ user.user_id }}</td>
          <td>{{ user.user_name }}</td>
          <td>{{ user.e_mail }}</td>
          <td>{{ user.first_name }}</td>
          <td>{{ user.last_name }}</td>
          <td>{{ user.phone_number }}</td>
          <td>{{ user.country }}</td>
          <td>{{ user.address }}</td>
          <td>{{ user.gender }}</td>
          <td>{{ user.birth_date }}</td>
          <td>{{ user.account_status }}</td>
          <td>{{ formatDateTime(user.last_login) }}</td>
          <td>{{ getRoleName(user.role_id) }}</td>
          <td>
            <select v-model="user.verified_level" @change="updateLevel(user)">
              <option v-for="level in levels" :key="level.value" :value="String(level.value)">
                {{ level.label }}
              </option>
            </select>
          </td>
          <td>
            <button @click="editUser(user)">Düzenle</button>
            <button class="deletebutton" v-if="showDeleteButtons" @click="deleteUser(user.user_id)">Sil</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      users: [],
      roles: [],
      selectedUser: {
        user_name: '',
        e_mail: '',
        password: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        country: '',
        address: '',
        gender: '',
        birth_date: '',
        account_status: 'Active',
        role_id: 16,
        verified_level: "1",
      },
      isEdit: false,
      showDeleteButtons: false,
      searchEmail: '',
      searchPhone: '',
      sortKey: 'user_id',
      sortOrder: 'desc',
      levels: [
        { value: 1, label: "Yeni Üye" },
        { value: 2, label: "Onaylı Üye" },
        { value: 3, label: "Destek Ekibi" },
        { value: 4, label: "Yönetim / Lider" },
        { value: 5, label: "Rise" },
        { value: 6, label: "Expert" },
        { value: 7, label: "Master" },
        { value: 8, label: "Elite Master" },
        // Diğer seviyeler için basitçe numara göster
        ...Array.from({length: 12}, (_, i) => ({
          value: 9 + i,
          label: `Seviye ${9 + i}`
        })),
      ],
    };
  },
  computed: {
    filteredUsers() {
      return this.users.filter(user => 
        (this.searchEmail ? user.e_mail.toLowerCase().includes(this.searchEmail.toLowerCase()) : true) &&
        (this.searchPhone ? (user.phone_number || '').includes(this.searchPhone) : true)
      );
    },
    sortedFilteredUsers() {
      let arr = [...this.filteredUsers];
      const key = this.sortKey;
      const order = this.sortOrder;

      arr.sort((a, b) => {
        let valA = a[key];
        let valB = b[key];
        if (valA === undefined || valA === null) valA = '';
        if (valB === undefined || valB === null) valB = '';
        const isNumber = !isNaN(Number(valA)) && !isNaN(Number(valB));
        if (isNumber) {
          valA = Number(valA);
          valB = Number(valB);
        } else {
          valA = String(valA).toLowerCase();
          valB = String(valB).toLowerCase();
        }
        if (valA < valB) return order === 'asc' ? -1 : 1;
        if (valA > valB) return order === 'asc' ? 1 : -1;
        return 0;
      });
      return arr;
    },
  },
  methods: {
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = key === 'user_id' ? 'desc' : 'asc';
      }
    },
    async fetchUsers() {
      try {
        const response = await axios.get('/admin/mainusers');
        this.users = response.data.map(u => ({ ...u, verified_level: String(u.verified_level || "1") }));
      } catch (error) {
        console.error('Kullanıcılar getirilirken hata:', error);
      }
    },
    async fetchRoles() {
      try {
        const response = await axios.get('/admin/roles');
        this.roles = response.data;
      } catch (error) {
        console.error('Roller getirilirken hata:', error);
      }
    },
    async createUser() {
      try {
        await axios.post('/admin/mainusers', this.selectedUser);
        this.fetchUsers();
        this.resetForm();
      } catch (error) {
        console.error('Kullanıcı oluşturulurken hata:', error);
      }
    },
    async updateUser() {
      try {
        await axios.put(`/admin/mainusers/${this.selectedUser.user_id}`, this.selectedUser);
        this.fetchUsers();
        this.resetForm();
        this.isEdit = false;
      } catch (error) {
        console.error('Kullanıcı güncellenirken hata:', error);
      }
    },
    editUser(user) {
      this.selectedUser = { ...user, verified_level: String(user.verified_level || "1") };
      this.isEdit = true;
    },
    async deleteUser(id) {
      if (confirm('Bu kullanıcıyı silmek istediğinize emin misiniz?')) {
        try {
          await axios.delete(`/admin/mainusers/${id}`);
          this.fetchUsers();
        } catch (error) {
          console.error('Kullanıcı silinirken hata:', error);
        }
      }
    },
    resetForm() {
      this.selectedUser = {
        user_name: '',
        e_mail: '',
        password: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        country: '',
        address: '',
        gender: '',
        birth_date: '',
        account_status: 'Active',
        role_id: 16,
        verified_level: "1",
      };
      this.isEdit = false;
    },
    getRoleName(roleId) {
      const role = this.roles.find(r => r.role_id === roleId);
      return role ? role.role_name : 'Bilinmiyor';
    },
    async updateLevel(user) {
      try {
        await axios.put(`/admin/mainusers/${user.user_id}`, { verified_level: user.verified_level });
        this.fetchUsers();
      } catch (error) {
        console.error('Level güncellenirken hata:', error);
      }
    },
    formatDateTime(dt) {
      if (!dt) return '';
      const d = new Date(dt);
      return d.toLocaleString('tr-TR');
    }
  },
  mounted() {
    this.fetchUsers();
    this.fetchRoles();
  },
};
</script>


<style scoped>
.search-filters {
  margin-bottom: 10px;
  display: flex;
  gap: 10px;
} 
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 2rem; 
}

button {
  margin-right: 10px;
}
</style>
